import type { MutationTree } from 'vuex';

import type { SelectOption } from '@emobg/web-components/loader';
import type { Dictionary } from '@emobg/web-utils';

import type { AvailableBrands } from '@/utils/get-brand.util';

import type { Country } from '../Broker/interfaces';
import type { AppState, BrokerData, CitiesState } from './interfaces';

export enum AppMutations {
  ToggleLoading = 'App:TOGGLE_LOADING',
  SetTranslation = 'App:SET_TRANSLATION',
  SetBrokerData = 'App:SET_BROKER_DATA',
  SetCountries = 'App:SET_COUNTRIES',
  SetProvinces = 'App:SET_PROVINCES',
  SetCities = 'App:SET_CITIES',
  SetBrand = 'App:SET_BRAND',
}

export interface AppData {
  [AppMutations.SetBrokerData]: (state: AppState, brokerData: BrokerData) => void;
  [AppMutations.SetTranslation]: (state: AppState, translation: Dictionary<string>) => void;
  [AppMutations.ToggleLoading]: (state: AppState) => void;
  [AppMutations.SetCountries]: (state: AppState, countries: Country[]) => void;
  [AppMutations.SetProvinces]: (state: AppState, provinces: SelectOption<string>[]) => void;
  [AppMutations.SetCities]: (state: AppState, cities: CitiesState) => void;
  [AppMutations.SetBrand]: (state: AppState, brand: AvailableBrands) => void;
}

export const mutations: MutationTree<AppState> & AppData = {
  [AppMutations.SetBrokerData](state, brokerData) {
    state.brokerData = brokerData;
  },

  [AppMutations.SetTranslation](state, translations) {
    state.translations = translations;
  },

  [AppMutations.ToggleLoading](state) {
    state.isLoading = !state.isLoading;
  },

  [AppMutations.SetCountries](state, countries: Country[]) {
    state.countries = countries;
  },
  [AppMutations.SetProvinces](state, provinces) {
    state.provinces = provinces;
  },
  [AppMutations.SetCities](state, cities) {
    state.cities = cities;
  },
  [AppMutations.SetBrand](state, brand) {
    state.brand = brand;
  },
} as const;
